import React, { useState } from "react";
import { Dialog, InputAdornment, TextField, Drawer, FormControlLabel, Checkbox, Divider, FormControl, Select, MenuItem } from "@material-ui/core";
import InfiniteScroll from "react-infinite-scroller";
import { P_Props } from "./QuotationList.type";
import moment from "moment";
import { FloatingButton, Loading, Notification, Pulse, CustomButton, CustomStatus } from "../../../components";
import { Search as SearchIcon } from "@material-ui/icons";
import { PriorityHigh as PriorityHighIcon, Close as CloseIcon, VisibilityOutlined as VisibilityOutlinedIcon } from "@material-ui/icons";
import { QuotationForm, QuotationDetail } from "../..";
import { DeleteIcon, ECommerceIcon, FreightForwardingIcon, FilterIcon, ExportIcon } from "../../../icons";
import { QuotationOutputModel, QuotationOptionService, QuotationStatus } from "../../../../models";

const QuotationListPresenter: React.FC<P_Props> = (props) => {
  const [visibleQuotationCreateModal, setVisibleQuotationCreateModal] = useState<boolean>(false);
  const [visibleDeleteModal, setVisibleDeleteModal] = useState<boolean>(false);
  const [visibleFloatingBtn, setVisibleFloatingBtn] = useState<boolean>(false);

  const [quotationDelete, setQuotationDelete] = useState<QuotationOutputModel | undefined>();
  const [openFilter, setOpenFilter] = useState<boolean>(false);
  const [optionService, setOptionService] = useState<QuotationOptionService>(QuotationOptionService.FREIGHTFORWARDING);

  const toggleDeleteModal = (quotation) => {
    if (quotation) {
      setQuotationDelete(quotation);
    }
    setVisibleDeleteModal(!visibleDeleteModal);
  };

  const toggleFloatingBtn = () => {
    setVisibleFloatingBtn(!visibleFloatingBtn);
  };

  const openFilterForm = () => {
    setOpenFilter(true);
  };

  const closeFilterForm = () => {
    setOpenFilter(false);
  };

  return (
    <>
      <div className="quotation-listing">
        <div className="quotation-listing__content">
          <div className="quotation-listing__content__header">
            <div className="quotation-listing__content__header__title">Quotation Requests</div>
            <div className="quotation-listing__content__header__actions">
              <div className="quotation-listing__content__header__search">
                <TextField
                  placeholder="Search by name, ID"
                  variant="outlined"
                  className="search-input"
                  inputProps={{ className: "input" }}
                  InputProps={{
                    // style: { fontSize: "1.4rem" },
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon className="icon" />
                      </InputAdornment>
                    ),
                  }}
                  onChange={(e) => {
                    props.onSearch(e.target.value);
                  }}
                />
              </div>
              <div className="quotation-listing__content__header__filter" onClick={openFilterForm}>
                <FilterIcon size={[18, 18]} viewBox={[18, 18]} color={"#272B2F"} />
                <h4 className="quotation-listing__content__header__filter__title">Filter</h4>
              </div>
              <div className="quotation-listing__content__header__export" onClick={props.exportToXLSX}>
                <ExportIcon size={[16, 16]} viewBox={[16, 16]} color={"#272B2F"} />
                <h4 className="quotation-listing__content__header__export__title">Export</h4>
              </div>
              {/* <button onClick={props.exportToXLSX}>Export</button> */}
            </div>
          </div>
          <div 
            className="quotation-listing__content__list"
            style={{ 
              opacity: visibleFloatingBtn ? "0.25" : "1", 
              pointerEvents: visibleFloatingBtn ? "none" : "auto"
            }}
          >
            <div className="quotation-listing__content__list__header">
              <div className="text quotation-listing__content__list__index">Order no.</div>
              <div className="text quotation-listing__content__list__code">Quote ID</div>
              <div className="text quotation-listing__content__list__customer">Customer</div>
              <div className="text quotation-listing__content__list__service">Service</div>
              <div className="text quotation-listing__content__list__status">Status</div>
              <div className="text quotation-listing__content__list__date">Request Date</div>
              <div className="text quotation-listing__content__list__actions"></div>
            </div>
            <InfiniteScroll
              useWindow={false}
              pageStart={1}
              initialLoad={false}
              hasMore={!props.fetchedQuotation.loading && props.fetchedQuotation.totalPages > props.fetchedQuotation.page}
              loadMore={() => {
                props.onLoadMore();
              }}
            >
              {!Boolean(props.fetchedQuotation.data.length) && props.fetchedQuotation.loading && <Loading />}
              {props.fetchedQuotation.data.map((quotation, index) => {
                return (
                  <div
                    key={quotation.id}
                    className="quotation-listing__content__list__item"
                  >
                    <div className="quotation-text quotation-listing__content__list__index">{index + 1}</div>
                    <div className="quotation-text quotation-listing__content__list__code">{quotation.code}</div>
                    <div className="quotation-text quotation-listing__content__list__customer">{quotation.fullName}</div>
                    <div className="quotation-text quotation-listing__content__list__service">
                      {quotation.service === QuotationOptionService.FREIGHTFORWARDING
                        ? "Freight forwarding"
                        : quotation.service === QuotationOptionService.ECOMMERCE
                          ? "E-commerce fulfillment"
                          : ""
                      }
                    </div>
                    <div className="quotation-text quotation-listing__content__list__status">
                      <FormControl
                        style={{ width: "80%" }}
                        variant="outlined"
                        className="quotation-list__select">
                        <Select
                          value={quotation.status}
                          onChange={e => {props.handleChangeStatus(e, quotation.code)}}
                        >
                          <MenuItem value={QuotationStatus.NEW}>
                            <CustomStatus color="#08C4E3" title="New" style={{ textTransform: "capitalize" }} />
                          </MenuItem>
                          <MenuItem value={QuotationStatus.INPROGRESS}>
                            <CustomStatus color="#FFBC1F" title="In process" style={{ textTransform: "capitalize" }} />
                          </MenuItem>
                          <MenuItem value={QuotationStatus.CONFIRMED}>
                            <CustomStatus color="#4EAA39" title="Confirmed" style={{ textTransform: "capitalize" }} />
                          </MenuItem>
                          <MenuItem value={QuotationStatus.REJECTED}>
                            <CustomStatus color="#E53935" title="Rejected" style={{ textTransform: "capitalize" }} />
                          </MenuItem>
                        </Select>
                      </FormControl>
                    </div>
                    <div className="quotation-text quotation-listing__content__list__date">
                      {quotation.createdAt ? moment(quotation.createdAt).format("DD/MM/yyyy") : ""}
                    </div>
                    <div className="quotation-text quotation-listing__content__list__actions">
                      <CustomButton onClick={(e) => {
                        e.stopPropagation();
                        props.openQuotationDetailModal(quotation, quotation.id);
                      }}
                        color={"transparent"}
                        item={
                          <span>
                            <VisibilityOutlinedIcon style={{ fontSize: "2.5rem", color: "#272B2F" }} />
                          </span>
                        } />
                      <CustomButton
                        onClick={(e) => {
                          e.stopPropagation();
                          e.preventDefault();
                          toggleDeleteModal(quotation);
                        }}
                        color={"transparent"}
                        item={
                          <span>
                            <DeleteIcon size={[20, 20]} viewBox={[20, 20]} color={"#272B2F"} />
                          </span>
                        }
                      />
                    </div>
                  </div>
                );
              })}
              {Boolean(props.fetchedQuotation.data.length) && props.fetchedQuotation.loading && <Loading />}
            </InfiniteScroll>
          </div>
        </div>
      </div>

      <FloatingButton
        visible={visibleFloatingBtn}
        onClickPrimary={() => toggleFloatingBtn()}
        btns={[
          {
            color: "redOrange",
            title: "Freight Forwarding",
            icon: <FreightForwardingIcon size={[35, 30]} color="white" />,
            onClick: (e) => {
              setOptionService(QuotationOptionService.FREIGHTFORWARDING);
              setVisibleQuotationCreateModal(true)
            },
          },
          {
            color: "green",
            title: "E-commerce Fulfillment",
            icon: <ECommerceIcon size={[38, 37]} color="white" />,
            onClick: (e) => {
              setOptionService(QuotationOptionService.ECOMMERCE);
              setVisibleQuotationCreateModal(true)
            },
          },
        ]}
      />

      {/* Form Create Quotation */}
      <Dialog fullScreen open={visibleQuotationCreateModal}>
        <QuotationForm
          shipmentService={optionService}
          onCancel={() => {
            setVisibleQuotationCreateModal(false);
          }}
          onComplete_Create={() => {
            setVisibleQuotationCreateModal(false);
            props.reloadListingPage();
            toggleFloatingBtn();
          }}
        />
      </Dialog>

      {/* Quotation Detail*/}
      <Dialog fullScreen open={Boolean(props.visibleQuotationDetail)}>
        <QuotationDetail
          initial={props.visibleQuotationDetail}
          quotationId={props.visibleQuotationId}
          onClose={props.closeQuotationDetailModal}
        />
      </Dialog>

      <Notification
        visible={visibleDeleteModal}
        title="Delete Quotation"
        subTitle={`Are you sure you want to delete quotation “${quotationDelete?.code}“? This action cannot be undone`}
        icon={
          <Pulse color={"red"}>
            <div className="notification-icon-box red">
              <PriorityHighIcon style={{ fontSize: "5rem", color: "#fff" }} />
            </div>
          </Pulse>
        }
        actions={
          <>
            <button
              className="quotation-form__delete-modal__actions__cancel"
              onClick={() => {
                toggleDeleteModal(quotationDelete);
              }}
            >
              Cancel
            </button>
            <button
              className="quotation-form__delete-modal__actions__confirm"
              onClick={() => {
                toggleDeleteModal(quotationDelete);
                if (quotationDelete?.code) {
                  props.onDeleteQuotation(quotationDelete.code);
                }
              }}
            >
              Confirm
            </button>
          </>
        }
      />

      <Drawer anchor="right" open={openFilter} onClose={closeFilterForm}>
        <div className="drawer">
          <div className="drawer-header">
            <div className="drawer-header--title">Filter</div>
            <div className="drawer-header--close">
              <button
                onClick={closeFilterForm}
                className="simple-modal-header__close"
                style={{ marginRight: "2.6rem" }}
              >
                <CloseIcon style={{ fontSize: "2.2rem" }} />
              </button>
            </div>
          </div>
          <div className="drawer-body--field">
            <div className="drawer-body--field__title">Service</div>
            <FormControlLabel
              control={
                <Checkbox
                  checked={props.statusFilterAll}
                  onChange={e => props.handleChangeCheckBoxAll(e)}
                  name="all"
                />
              }
              label="All"
            />
            <Divider />
            <FormControlLabel
              control={
                <Checkbox
                  checked={props.statusFilter.freight_forwarding}
                  onChange={e => props.handleChangeCheckBox(e)}
                  name="freight_forwarding"
                />
              }
              label="Freight Forwarding"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={props.statusFilter.ecommerce_fulfillment}
                  onChange={e => props.handleChangeCheckBox(e)}
                  name="ecommerce_fulfillment"
                />
              }
              label="E-commerce Fulfillment"
            />
          </div>
          <div className="drawer-footer">
            <button
              type="reset"
              className="btn cancel"
              onClick={props.clearFilter}
            >
              Clear filter
            </button>
            <button
              className="btn save"
              onClick={() => {
                closeFilterForm();
                props.onApplyStatusFilter();
              }}
            >
              Apply
            </button>
          </div>
        </div>
      </Drawer>
    </>
  );
};

export default QuotationListPresenter;
